// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"84eae76c","3":"cd77bba2","51":"4ea21f6b","134":"72d2b9d9","237":"0a333b3e","275":"e9bc79ef","428":"4fbf91ed","453":"2f48f22f","458":"d0ac266d","588":"978f84ef","638":"3f41681c","720":"8a22f08e","744":"bd0e9335","814":"289b32d2"}[chunkId] + ".chunk.js";
};